'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutHelp = (_dec = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(CheckoutHelp, _React$Component);

  function CheckoutHelp() {
    (0, _classCallCheck3.default)(this, CheckoutHelp);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutHelp.__proto__ || (0, _getPrototypeOf2.default)(CheckoutHelp)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutHelp, [{
    key: 'hide',
    value: function hide() {
      this.props.close();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { styleName: 'overlay', onClick: this.props.close }),
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          _react2.default.createElement(
            'div',
            { styleName: 'header' },
            _react2.default.createElement(
              'div',
              { styleName: 'text' },
              'What can I do if I\'m having trouble ordering online?'
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.hide.bind(this), styleName: 'closeButton' },
              _react2.default.createElement(_Icon2.default, { type: 'cross' })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'info' },
            _react2.default.createElement(
              'p',
              null,
              'We\u2019re having a little trouble processing your order at the moment. To help get things moving please can you check that the payment method you are using has been entered correctly.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Sometimes older browsers, cookies and cached data can cause hiccups in the processing. So please also check you\u2019re using the latest browser version & clear your history. Trying a different device can also help.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If you\u2019ve tried all of these options and you\u2019re still having trouble our experts in our Customer Advice Centre can help. Please call them on 0333 222 7171.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Their phone lines are opened between 08:30am \u2013 17:00pm Monday to Friday & 09:00am \u2013 12:30pm Saturday.'
            )
          )
        )
      );
    }
  }]);
  return CheckoutHelp;
}(_react2.default.Component)) || _class);
exports.default = CheckoutHelp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutHelp/index.js
// module id = 2270
// module chunks = 0